import { motion } from 'motion/react'
import styled, { css } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const RefundIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background-color: ${props => props.theme.splitButton.backgroundColor};
  padding: 8px;

  svg {
    color: ${props => props.theme.splitButton.iconColor};
    fill: ${props => props.theme.splitButton.iconColor};

    path {
      fill: ${props => props.theme.splitButton.iconColor};
    }
  }
`

export const TotalAmountContainer = styled.div`
  border-top: 1px solid ${props => props.theme.splitButton.borderColor};
  width: calc(100%);
  margin-left: -16px;
  padding: 8px 16px 8px 16px;
  border-radius: 0 0 16px 16px;
  background-color: ${props => props.theme.splitButton.backgroundColor};
  color: ${props => props.theme.splitButton.iconColor};
`

export const RefundOptionTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.splitButton.color};
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const HelperText = styled(Text)`
  color: ${props => props.theme.splitButton.color};
  user-select: none;
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const RefundOption = styled(motion.div)`
  border-radius: 16px;
  padding: ${props => props.theme.whiteLabel.spacing.sp16};
  padding-bottom: 0px;
  border: 1px solid ${props => props.theme.splitButton.borderColor};
  display: flex;
  flex-direction: column;
  gap: 8px;
  user-select: none;

  ${props =>
    props.isSelected &&
    css`
      border-color: ${props => props.theme.splitButton.selected.borderColor}!important;
      color: ${props => props.theme.splitButton.selected.color}!important;
      & > p {
        color: ${props => props.theme.splitButton.selected.iconColor}!important;
      }

      ${RefundIconContainer} {
        background-color: ${props => props.theme.splitButton.selected.backgroundColor}!important;

        svg {
          color: ${props => props.theme.splitButton.selected.iconColor}!important;
          fill: ${props => props.theme.splitButton.selected.iconColor}!important;

          path {
            fill: ${props => props.theme.splitButton.selected.iconColor}!important;
          }
        }
      }

      ${TotalAmountContainer} {
        background-color: ${props => props.theme.splitButton.selected.backgroundColor}!important;
        color: ${props => props.theme.splitButton.selected.iconColor}!important;
        border-top: 1px solid ${props => props.theme.colors.white}!important;
      }

      ${RefundOptionTitleContainer} {
        & > p {
          color: ${props => props.theme.splitButton.selected.color}!important;
        }
      }

      ${HelperText} {
        color: ${props => props.theme.splitButton.selected.color}!important;
      }
    `}

  &:hover {
    cursor: pointer;
    border-color: ${props => props.theme.splitButton.hover.borderColor};
    color: ${props => props.theme.splitButton.hover.color};
    p {
      color: ${props => props.theme.splitButton.hover.iconColor};
    }

    ${RefundIconContainer} {
      background-color: ${props => props.theme.splitButton.hover.backgroundColor};

      svg {
        color: ${props => props.theme.splitButton.hover.iconColor};
        fill: ${props => props.theme.splitButton.hover.iconColor};

        path {
          fill: ${props => props.theme.splitButton.hover.iconColor};
        }
      }
    }

    ${TotalAmountContainer} {
      background-color: ${props => props.theme.splitButton.hover.backgroundColor};
      color: ${props => props.theme.splitButton.hover.iconColor};
      border-top: 1px solid ${props => props.theme.colors.white};
    }

    ${RefundOptionTitleContainer} {
      & > p {
        color: ${props => props.theme.splitButton.hover.color};
      }
    }

    ${HelperText} {
      color: ${props => props.theme.splitButton.hover.color}!important;
    }
  }
`

export const RefundOptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: ${props => props.theme.texts.titleS.fontSize};
  font-family: ${props => props.theme.texts.titleS.fontFamily};
  color: ${props => props.theme.splitButton.color};

  p {
    user-select: none;
    margin: 0;
  }
`

export const RefundOptionChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`
